import modalChangePassword from '@/components/OpenCall/changePassword/changePassword.vue'
import editIcon from '@/components/Icons/Edit/Edit.vue'
import iconPencilSquare from '@/components/Icons/PencilSquare/PencilSquare.vue';
import { async } from 'q';
import alerts from '@/components/Alert/Alert.vue'
import modalConfirm from '@/components/Tools/Confirm/Confirm.vue';
import modalNewEdition from '@/components/Manager/newEdition/newEdition.vue';

export default {
    name: 'User',

    components: {
        modalChangePassword,
        editIcon,
        iconPencilSquare,
        alerts,
        modalConfirm,
        modalNewEdition

    },

    props: ['edition'],

    data() {
        return {

            _aws_urlFile: "",
            actual_edition: "",
            loader: false,
            selected: [],
            selectAll: false,

            view_title: false,

            temp_obras: [],
            temp_portafolio: [],

            actual_order: null,

            menu: false,
            menuUser: 0,
            picked: false,
            modal_changePassword: false,
            modal_newEdition: false,

            alert_temp: {
                status: false,
                label: "",
                type: ""
            },

            modal_confirm: {
                status: false,
                title: "",
                text: "",
                question: "",
                callback: ""
            },


            /**     FILTERS     */
            tempSelect: "Selecciona...",
            typeSelectFlag: false,
            options: [
                { label: 'Alfabéticamente', value: 'alpha' },
                { label: 'Mayor a menor promedio', value: 'higher' },
                { label: 'Menor a mayor promedio', value: 'less' }
            ],

            search: "",

            actualKey: 0,
            score: 0,
            noScore: 5,
            managers: [],
            managers_list: false,
            opencall: {
                curriculum_vitae: "(...)",
                email: "(...)",
                finished: true,
                name: "(...)",
                obras: {},
                personal_data: {},
                portafolio: {},
                removed: false,
                status: "(...)",
                _id: "(...)",
                managers: []
            },
            admin_controls: {
                status_opencall: false,
                status_evaluation: false,
                count_finalists: 0,
                count_winners: 0,
            },
            items: [
                {
                    'id': '1',
                    'artist': 'a. de Carmen Reynoso Portillo',
                    'calification': 'pendiente',
                    '': { '2018-09-09': '{{asd}}<div></div>' },
                },
                {
                    'id': '2',
                    'artist': 'rturo Miguel Aldana Hurtado',
                    'calification': '-',
                    '': { '2018-09-09': '{{asd}}<div></div>' },
                },
                {
                    'id': '3',
                    'artist': 'ector Guadalupe Aldaz Hernandez',
                    'calification': '4.4',
                    '': { '2018-09-09': '{{asd}}<div></div>' },
                },
            ],
            items_finalist: [],
            columns: [
                { label: 'Artista', name: 'name' },
                { label: 'Tu Calificación', name: 'score' },
                { label: 'Evaluación Administradores', name: 'admin_average' },
                { label: 'Acciones', name: 'action' },
            ],
            columns_finalists: [
                { label: 'Artista', name: 'name' },
                { label: 'Evaluación Consejo', name: 'comun_average' },
                { label: 'Acciones', name: 'action' },
            ]

        }
    },

    methods: {

        /** EDITIONS */
        /// Just Get Edition
        get_actual_edition() {
            if (this.$route.query.edition) {
                this.actual_edition = this.$route.query.edition;
            } else {
                this.actual_edition = this.$session.get('old_edition');
            }
            // this is, create url for conect to AWS with old edition
            this._aws_urlFile = this.$session.get("_aws_url") + this.actual_edition + "/";
        },
        /// Create Edition

        export_data() {
            // validate if  already selected a user
            if (false)
            // if(this.selected.length < 1)
            {
                /** Alert */
                this.alert_temp = {
                    status: true,
                    type: "warning",
                    label: "Selecciona algun usuario..."
                };
                setTimeout(() => { this.alert_temp.status = false; }, 3000);
                /** FIN Alerta */
            } else {
                (async () => {

                    await fetch('https://api.salonacme.com/manager/export_data-all-finalist', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            _id: this.$session.get('_id'),
                            users: this.selected
                        })
                    }).then(async response => {
                        response = await response.json();
                        if (response.status) {
                            window.open("https://api.salonacme.com/export/zipExport.zip");
                        } else {
                            /** Alert */
                            this.alert_temp = {
                                status: true,
                                type: "warning",
                                label: response.msg
                            };
                            setTimeout(() => { this.alert_temp.status = false; }, 3000);
                            /** FIN Alerta */
                            // alert(response.msg);
                        }

                    })
                        .catch(error => console.log(error));

                })();
            }
        },

        select() {
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.items_finalist) {
                    this.selected.push(this.items_finalist[i]._id);
                }
            }
        },

        obra_title(event) {
            // if text is more large to input with
            if (event.target.clientWidth < event.target.scrollWidth) {
                // document.getElementById("better-obra_title").setAttribute("style", " display: inline;");
                // document.getElementsByClassName("view_title").setAttribute("style", " display: inline;");
                this.view_title = true;

            }
        },
        obra_title_out() {
            // document.getElementById("better-obra_title").setAttribute("style", " display: none;");
            // document.getElementsByClassName("view_title").setAttribute("style", " display: none;");
            this.view_title = false;
        },
        async addImageProcess(src) {
            let img = new Image();
            img.src = src;
            return img.onload = await (() => {
                // console.log(this.height);
                return this.height;
            })
        },
        loadSprite(src, callback) {
            var sprite = new Image();
            sprite.onload = callback;
            sprite.src = src;
        },

        async checkImgs() {
            this.temp_portafolio = [];
            this.temp_obras = [];
            //// obras
            var keysToDelete = [];
            for (let i = 0; i < this.opencall.obras.length; i++) {
                var index = this.opencall.obras[i];

                // var url = "https://api.salonacme.com/image/" + index.file;
                var url = this._aws_urlFile + index.file;
                if (index.file != '' && index.file.split('.')[1] !== 'pdf') {
                    var objImg = new Image();
                    // var tmp = new Temp();
                    // objImg.src = 'https://api.salonacme.com/image/'+index.file;
                    // var res = this.addImageProcess('https://api.salonacme.com/image/'+index.file);
                    // var res = this.addImageProcess('https://api.salonacme.com/image/'+index.file)
                    // var res = await objImg.onload();

                    // this.loadSprite('https://api.salonacme.com/image/' + index.file, (e) => {
                    this.loadSprite(this._aws_urlFile + index.file, (e) => {

                        // code to be executed later
                        // console.log('Regreso de cArgar-------------');
                        // objImg = e.explicitOriginalTarget;
                        // console.log(e);
                        if (typeof e.explicitOriginalTarget === 'undefined' && typeof e.path !== 'undefined') {
                            objImg = e.path[0];
                            if (objImg.height != 0 || objImg.width != 0) {
                                this.temp_obras.push(this.opencall.obras[i]);
                            }
                        }
                        else if (typeof e.target !== 'undefined') {
                            objImg = e.target;
                            if (objImg.height != 0 || objImg.width != 0) {
                                this.temp_obras.push(this.opencall.obras[i]);
                            }
                        }
                        else {
                            objImg = e.target;
                            if (objImg.naturalHeight != 0 || objImg.naturalWidth != 0 ||
                                objImg.height != 0 || objImg.width != 0) {
                                this.temp_obras.push(this.opencall.obras[i]);
                            }
                        }

                    });
                    // console.log(res)
                    // console.log(res);

                    // if(objImg.naturalHeight<1 && objImg.naturalWidth<1)
                    // {
                    //     keysToDelete.push(i);
                    // }
                    // console.log('obras', objImg.naturalHeight != 0 || objImg.naturalWidth != 0 ||
                    // objImg.height != 0 || objImg.width != 0 );
                    // console.log(objImg.height);
                    // console.log(objImg.width);
                    // console.log(objImg);
                    // if(objImg.naturalHeight != 0 || objImg.naturalWidth != 0 ||
                    //     objImg.height != 0 || objImg.width != 0)
                    // {
                    //     this.temp_obras.push(this.opencall.obras[i]);
                    // }
                    // objImg = null;
                }

                else if (index.file != '' && index.file.split('.')[1] === 'pdf') {

                    this.pdfExist_obras(url, i);

                }

                else {
                    this.temp_obras.push(this.opencall.obras[i]);
                }

            }
            // for(var i = 0; i < keysToDelete.length; i++) {
            //     this.opencall.obras.splice(keysToDelete[i], 1);
            // }

            //// portafolio
            var keysToDelete = [];
            for (let i = 0; i < this.opencall.portafolio.length; i++) {
                var index = this.opencall.portafolio[i];

                // var url = "https://api.salonacme.com/image/" + index.file;
                var url = this._aws_urlFile + index.file;
                if (index.file != '' && index.file.split('.')[1] !== 'pdf') {
                    var objImg_2 = new Image();
                    // objImg_2.src = 'https://api.salonacme.com/image/'+index.file;
                    // if(objImg_2.naturalHeight<1 && objImg_2.naturalWidth<1)
                    // {
                    //     keysToDelete.push(i);
                    // }
                    // console.log('porta', objImg_2.naturalHeight != 0 || objImg_2.naturalWidth != 0 ||
                    // objImg_2.height != 0 || objImg_2.width != 0 );
                    // console.log(objImg_2.height);
                    // console.log(objImg_2.width);
                    // console.log(objImg_2);
                    // if(objImg_2.naturalHeight != 0 || objImg_2.naturalWidth != 0 ||
                    //     objImg_2.height != 0 || objImg_2.width != 0)
                    // {
                    //     this.temp_portafolio.push(this.opencall.portafolio[i]);
                    // }
                    // objImg_2 = null;

                    // this.loadSprite('https://api.salonacme.com/image/' + index.file, (e) => {
                    this.loadSprite(this._aws_urlFile + index.file, (e) => {

                        // code to be executed later
                        // console.log('Regreso de cArgar-------------');
                        objImg_2 = e.explicitOriginalTarget;

                        if (typeof e.explicitOriginalTarget === 'undefined' && typeof e.path !== 'undefined') {
                            objImg_2 = e.path[0];
                            if (objImg_2.height != 0 || objImg_2.width != 0) {
                                this.temp_portafolio.push(this.opencall.portafolio[i]);
                            }
                        }
                        else if (typeof e.target !== 'undefined') {
                            objImg_2 = e.target;
                            if (objImg_2.height != 0 || objImg_2.width != 0) {
                                this.temp_portafolio.push(this.opencall.portafolio[i]);
                            }
                        }
                        else {
                            objImg_2 = e.target;
                            if (objImg_2.naturalHeight != 0 || objImg_2.naturalWidth != 0 ||
                                objImg_2.height != 0 || objImg_2.width != 0) {
                                this.temp_portafolio.push(this.opencall.portafolio[i]);
                            }
                        }

                    });
                }

                else if (index.file != '' && index.file.split('.')[1] === 'pdf') {

                    this.pdfExist_portafolio(url, i);

                }

                else {
                    this.temp_portafolio.push(this.opencall.portafolio[i]);
                }

            }
            // for(var i = 0; i < keysToDelete.length; i++) {
            //     this.opencall.portafolio.splice(keysToDelete[i], 1);
            // }
            // console.log(this.opencall.obras);
            // console.log(this.temp_obras);
            // console.log(this.opencall.portafolio);
            // console.log(this.temp_portafolio);

            // vm.$forceUpdate();
            this.$forceUpdate();

        },
        pdfExist_obras(link, index) {
            var i = index;
            var url = link;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onprogress = (event) => {
                if (event.lengthComputable) {
                    // console.log('isgood');
                    this.temp_obras.push(this.opencall.obras[i]);
                } else {
                    // this.opencall.obras.splice(index, 1);
                }
                xhr.abort();
            };
            xhr.send();
        },
        pdfExist_portafolio(link, index) {
            var i = index;
            var url = link;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onprogress = (event) => {
                if (event.lengthComputable) {
                    // console.log('isgood');
                    this.temp_portafolio.push(this.opencall.portafolio[i]);
                } else {
                    // this.opencall.portafolio.splice(index, 1);

                }
                xhr.abort();
            };
            xhr.send();
        },


        convertToMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            } catch (e) {
            }
        },
        isCompleteUrl(value) {
            var url = value;
            return url.search("http") >= 0
                ? (url)
                : ('//' + url)
        },
        backOpenCall() {
            if (this.actualKey > 0) {
                this.actualKey--;
                this.actions(this.items[this.actualKey]._id);
                // return to personal data
                this.menuUser = 0;
            }
        },
        nextOpenCall() {
            if (this.actualKey < this.items.length - 1) {
                this.actualKey++;
                this.actions(this.items[this.actualKey]._id);
                // return to personal data
                this.menuUser = 0;
            }
        },
        actions(id, key = null, tempType = null) { // Load opencall data
            this.$root.opencall_view = false;
            if (key != null) // i think is to next and before
                this.actualKey = key;
            if (tempType == null) {
                var type = 'admin';
            } else {
                var type = tempType;
            }
            (async () => {

                await fetch('https://api.salonacme.com/manager/get_opencall_oldEdition', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        _id: this.$session.get('_id'),
                        _id_opencall: id,
                        type: type,
                        edition: this.actual_edition
                    })
                }).then(async response => {
                    response = await response.json();
                    if (response.status) {
                        this.score = response.score;
                        this.opencall = (response.opencall);
                        this.managers = response.managers;



                        this.checkImgs();

                    } else {
                        this.$root.opencall_view = true;
                        /** Alert */
                        this.alert_temp = {
                            status: true,
                            type: "warning",
                            label: response.msg
                        };
                        setTimeout(() => { this.alert_temp.status = false; }, 3000);
                        /** FIN Alerta */

                        // alert(response.msg);
                    }

                })
                    .catch(error => {
                        console.log(error);
                    });

            })();

        },
        get_controls() {

            (async () => {

                await fetch('https://api.salonacme.com/manager/get_control', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        _id: this.$session.get('_id'),
                    })
                }).then(async response => {
                    response = await response.json();
                    if (response.status) {
                        this.admin_controls = response.controls;
                    } else {
                        /** Alert */
                        this.alert_temp = {
                            status: true,
                            type: "warning",
                            label: response.msg
                        };
                        setTimeout(() => { this.alert_temp.status = false; }, 3000);
                        /** FIN Alerta */
                        // alert(response.msg);
                    }

                })
                    .catch(error => {
                        console.log(error);
                    });

            })();

        },
        get_opencalls(order = null, search = null) { /// Load all Opencalls
            this.loader = true;
            (async () => {

                await fetch('https://api.salonacme.com/manager/get_opencalls_oldEdition', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        _id: this.$session.get('_id'),
                        order: order,
                        search: search,
                        edition: this.actual_edition
                    })
                }).then(async response => {
                    response = await response.json();
                    if (response.status) {
                        this.items = response.opencalls;

                        for (let index = 0; index < this.items.length; index++) {
                            if(this.items[index].admin_average)
                                this.items[index].admin_average = parseFloat( this.items[index].admin_average).toFixed(2);
                        }

                        if (order == 'higher' && search == null)
                            this.items.sort(function (a, b) {
                                if (a.admin_average > b.admin_average) {
                                    return -1;
                                }
                                if (a.admin_average < b.admin_average) {
                                    return 1;
                                }
                                // a must be equal to b
                                return 0;
                            });
                        if (order == 'less' && search == null)
                            this.items.sort(function (a, b) {
                                if (a.admin_average > b.admin_average) {
                                    return 1;
                                }
                                if (a.admin_average < b.admin_average) {
                                    return -1;
                                }
                                // a must be equal to b
                                return 0;
                            });

                    } else {
                        /** Alert */
                        this.alert_temp = {
                            status: true,
                            type: "warning",
                            label: response.msg
                        };
                        setTimeout(() => { this.alert_temp.status = false; }, 3000);
                        /** FIN Alerta */
                        // alert(response.msg);
                    }

                })
                .catch(error => {
                    // console.log(error);
                });
                this.loader = false;

            })();

        },
        get_opencalls_finalist(order = null, search = null) {

            (async () => {

                await fetch('https://api.salonacme.com/manager/get_opencalls_oldEdition_finalist', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        _id: this.$session.get('_id'),
                        order: order,
                        search: search,
                        edition: this.actual_edition
                    })
                }).then(async response => {
                    response = await response.json();
                    if (response.status) {

                        this.items_finalist = response.opencalls;
                        
                        for (let index = 0; index < this.items_finalist.length; index++) {
                            if(this.items_finalist[index].comun_average)
                                this.items_finalist[index].comun_average = parseFloat(this.items_finalist[index].comun_average).toFixed(2);
                        }

                        if (order == 'higher' && search == null)
                            this.items_finalist.sort(function (a, b) {
                                if (a.comun_average > b.comun_average) {
                                    return -1;
                                }
                                if (a.comun_average < b.comun_average) {
                                    return 1;
                                }
                                // a must be equal to b
                                return 0;
                            });
                        if (order == 'less' && search == null)
                            this.items_finalist.sort(function (a, b) {
                                if (a.comun_average > b.comun_average) {
                                    return 1;
                                }
                                if (a.comun_average < b.comun_average) {
                                    return -1;
                                }
                                // a must be equal to b
                                return 0;
                            });



                    } else {
                        // alert(response.msg);
                    }

                })
                    .catch(error => console.log(error));

            })();

        },
        callOrder(order) {
            this.actual_order = order;
            this.get_opencalls(order);
        },
        callOrder_finalist(order) {
            this.actual_order = order;
            this.get_opencalls_finalist(order);
        },
        searchF() {
            this.get_opencalls(null, this.search);
        },
        searchF_finalist() {
            this.get_opencalls_finalist(null, this.search);
        },
        confirms(opc) {
            switch (opc) {
                case "changeStatusOpencall":
                    if (this.modal_confirm.response) {
                        this.changeStatusOpencall();
                    }
                    else {
                        setTimeout(() => {
                            this.admin_controls.status_opencall = !this.admin_controls.status_opencall;
                        }, 100);
                    }
                    break;
                case "changeStatusEvaluation":
                    if (this.modal_confirm.response) {
                        this.changeStatusEvaluation();
                    }
                    else {
                        setTimeout(() => {
                            this.admin_controls.status_evaluation = !this.admin_controls.status_evaluation;
                        }, 100);
                    }
                    break;

                case "createEdition":
                    if (this.modal_confirm.response) {
                        this.createEdition();
                    }
                    else {
                        setTimeout(() => {

                        }, 100);
                    }
                    break;

                default:
                    break;
            }
        },
        myMounted() {
            // this.data();
            // console.log(this.edition);
            // console.log(this.$root.$route.fullPath);
            // console.log('mounted ejecutandoce..');
            this.get_actual_edition();
            // this.get_controls();
            this.get_opencalls();
            this.get_opencalls_finalist();
            // location.reload();
        }

    },
    watch: {
        score: function (newQuestion) {
            this.noScore = 5 - this.score;
        },
        '$root.opencall_view': function (newQuestion) {
            if (this.$root.opencall_view)
                this.get_opencalls(this.actual_order);
        },
        '$root.$route.fullPath': function (newQuestion) {
            // console.log(this.$root.$route.fullPath);
            this.myMounted();
            // location.reload();
        },
        // '$root.fullPath': function (newQuestion) {
        //     console.log(this.$root.fullPath);
        // },
    },

    mounted() {
        this.myMounted();
        // location.reload();
    }


}
